import { useCallback, useEffect, useState } from 'react';

const STORAGE_PREFIX = 'edvise.pageTutorial.seen.';

export function getPageTutorialStorageKey(sessionId) {
  return `${STORAGE_PREFIX}${sessionId}`;
}

/**
 * @param {string} sessionId - e.g. jupas, report, ability
 * @param {{ forceOpen?: boolean, autoShowFirstVisit?: boolean }} options
 */
export function usePageTutorial(sessionId, { forceOpen = false, autoShowFirstVisit = false } = {}) {
  const [guideOpen, setGuideOpen] = useState(false);
  const storageKey = getPageTutorialStorageKey(sessionId);

  useEffect(() => {
    if (forceOpen) {
      setGuideOpen(true);
      return;
    }
    if (!autoShowFirstVisit) return;
    try {
      if (!localStorage.getItem(storageKey)) {
        setGuideOpen(true);
      }
    } catch {
      setGuideOpen(true);
    }
  }, [forceOpen, autoShowFirstVisit, storageKey]);

  const openGuide = useCallback(() => setGuideOpen(true), []);
  const closeGuide = useCallback(() => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      /* ignore */
    }
    setGuideOpen(false);
  }, [storageKey]);

  return { guideOpen, openGuide, closeGuide };
}
